/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CloudWasteSetting } from "~/generated/graphql";
import { CloudWasteSettingsForm } from "./CloudWasteSettingsForm";

export type UpdatedSettings = Parameters<
  React.ComponentProps<typeof CloudWasteSettingsForm>["onSubmit"]
>[0];

export type Settings = CloudWasteSetting[];

export enum DAY_OF_WEEK {
  SUN = "sun",
  MON = "mon",
  TUE = "tue",
  WED = "wed",
  THU = "thu",
  FRI = "fri",
  SAT = "sat",
}
